const about = {
  pageTitle: '关于我们',
  pageDescription: '了解岛国精品的品牌故事、发展历程、品质承诺和联系方式。我们致力于为中国消费者带来最纯正的日本商品体验。',
  brandIntro: '品牌介绍',
  brandIntroContent: '岛国精品成立于2018年，总部位于上海，是一家专注于日本原装进口商品的精选平台。我们与超过200家日本知名品牌建立了直接合作关系，涵盖美妆护肤、食品零食、家居日用、健康保健等多个品类。每一件上架商品都经过我们专业团队的严格筛选和品质把控，确保您收到的每一件商品都是真正的日本正品。',
  mission: '我们的使命',
  missionContent: '让每一位中国消费者都能轻松享受到来自日本的高品质生活体验。我们不仅提供商品，更致力于传递日本精致、用心、追求极致的生活理念。',
  vision: '我们的愿景',
  visionContent: '成为中国最受信赖的日本进口商品精选平台，搭建中日优质商品和文化的桥梁。',
  milestones: '发展历程',
  milestone2018: '岛国精品正式成立，首批合作20+日本品牌，上线官网',
  milestone2019: '合作品牌突破100家，仓储中心扩建至3000㎡',
  milestone2020: '推出直邮服务，覆盖全国200+城市',
  milestone2021: '平台注册用户突破50万，上线小程序商城',
  milestone2022: '合作品牌超过200家，SKU突破5000+',
  milestone2023: '获评\"最受消费者信赖进口电商平台\"',
  milestone2024: '全面升级仓储物流体系，实现48小时极速发货',
  reputation: '品牌口碑',
  reputationDesc: '来自真实用户的好评与信赖',
  contactTitle: '联系我们',
  contactDesc: '如有任何问题或合作意向，欢迎随时与我们联系',
  companyName: '岛国精品（上海）国际贸易有限公司',
  phone: '400-888-9999',
  email: 'service@daoguojingpin.com',
  address: '上海市浦东新区陆家嘴金融贸易区世纪大道100号',
  workingHours: '周一至周五 9:00 - 18:00',
  wechat: '岛国精品官方',
  formName: '姓名',
  formEmail: '邮箱',
  formPhone: '电话',
  formMessage: '留言内容',
  formSubmit: '提交留言',
  formSuccess: '感谢您的留言，我们会尽快回复！',
  formError: '提交失败，请稍后重试。',
};

export default about;